import egumaReact from "egumaReact"; // added in externals in webpack
import { Element } from "react-scroll";
import React, { Fragment } from "react";

import Polyglot from "node-polyglot";
const polyglot = new Polyglot({ phrases: egumaReact.translations });

function Capacities({ capacities, selectedCapacity, selectedTimeSlot, onSelect }) {
  if (!selectedTimeSlot || !egumaReact.hasMultipleCapacities) {
    return null;
  }

  return (
    <Element name="capacities">
      <div style={{ marginTop: 30 }}>
        <div>
          {polyglot.t("Backend.Ticketing.Calendar.PleaseChooseCapacity")}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginTop: 10
            }}
          >
            {capacities.map(({ id, enabled, title, capacity }, index) => (
              <div
                key={index}
                onClick={() => (enabled ? onSelect({ slotId: selectedTimeSlot, capacityId: id }) : null)}
              >
                <div
                  className={`calendar--timeslot${
                    enabled
                      ? " calendar--timeslot-enabled"
                      : " calendar--timeslot-disabled"
                  }${
                    selectedCapacity && selectedCapacity === id
                      ? " calendar--timeslot-selected"
                      : ""
                  }`}
                >
                  {title}
                  {egumaReact.showAvailability && (
                    <Fragment>
                      <br />
                      <div className="calendar--timeslot-available">
                        {enabled
                          ? polyglot.t("Shop.Calendar.TicketAmountAvailable", {
                            capacity
                          })
                          : polyglot.t("Common.SoldOut")}
                      </div>
                    </Fragment>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Element>
  );
}

export default Capacities;
